import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { createExhibitor } from "api/exhibitor.api";
import ExhibitorForm from "components/exhibitor/ExhibitorForm";


export default function CreateExhibitor() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");

  const handleSubmit = async (fd) => {
    try {
      await createExhibitor(fd);
      navigate("/admin/exhibitors");
    } catch (err) {
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  }; 

  return (
    <div className="p-6">
      <h2 className="mb-4 text-xl font-bold">Create Exhibitor</h2>
      <ExhibitorForm
        onSubmit={handleSubmit}
        onBack={() => navigate("/admin/exhibitors")}
        alert={alert}
        setAlert={setAlert}
      />
    </div>
  );
}